import React from "react";
const SvgFloorplan = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M20.9 4.5h-1.888a.5.5 0 000 1H20.4v4.047h-4.769a.5.5 0 000 1H20.4V18.5h-9.153v-1.505a.5.5 0 10-1 0V18.5H4v-6.036h6.247v1.195a.5.5 0 101 0v-3.612a.5.5 0 00-1 0v1.417H4V5.5h6.247v1.196a.499.499 0 101 0V5.5h4.049a.5.5 0 100-1H3.5A.5.5 0 003 5v14a.5.5 0 00.5.5h17.4a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5"
    />
  </svg>
);
export default SvgFloorplan;
